// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { miniMyAccountStyles } from "@tps/App/Components/MiniMyAccount/MiniMyAccount";
import IconTextLinkEditInactive from "@tps/XDL/Icons/IconTextLinkEditInactive";
import IconTextLinkSignoutInactive from "@tps/XDL/Icons/IconTextLinkSignoutInactive";
import { color, createLinkIconStyles } from "@tps/XDL/Utilities";
import { css } from "styled-components";

miniMyAccountStyles.mainTitle = {
    variant: "h5",
    forwardAs: "p",
    transform: "capitalize",
    css: css`
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

miniMyAccountStyles.linksSectionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

miniMyAccountStyles.linkItems = {
    wrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            column-gap: 16px;
            &:last-child {
                margin-bottom: 8px;
            }
            &:not(:first-child) {
                margin-top: 4px;
            }
        `,
    },
    link: {
        color: "common.ui6",
        typographyProps: {
            size: 12,
            weight: "normal",
            transform: "capitalize",
            css: css`
                letter-spacing: 0;
                line-height: 17px;
                margin-bottom: 12px;
            `,
        },
    },
    linkWrapper: {
        css: css`
            flex-basis: calc(50% - 8px);
            display: flex;
        `,
    },
};

miniMyAccountStyles.actionsWrapper = {
    css: css`
        padding-top: 16px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-top: 1px solid ${color("common.border")};
    `,
};

miniMyAccountStyles.changeCustomerLink = {
    ...createLinkIconStyles(IconTextLinkEditInactive, {
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 17px;
            `,
        },
    }),
};

miniMyAccountStyles.signOutLink = {
    ...createLinkIconStyles(IconTextLinkSignoutInactive, {
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 17px;
            `,
        },
        css: css`
            margin-left: auto;
        `,
    }),
};

miniMyAccountStyles.subTitle = {
    size: 14,
    weight: "bold",
    transform: "capitalize",
    css: css`
        line-height: 22px;
        width: 100%;
        margin-bottom: 8px;
    `,
};
